import { version } from '../../package.json'
import { $logger } from './logger'
import Rollbar from 'rollbar'
import 'rollbar/replay'

function isExtensionError(exception) {
  const { message = '', class: type = '' } = exception || {}
  return (
    message.includes('Object Not Found Matching Id') ||
    message.includes('MethodName:update') ||
    type.includes('(unknown)') ||
    (type.includes('[anonymous]') && !type.includes('webpack://'))
  )
}

export const $rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.DEV ? 'development' : import.meta.env.VITE_TARGET_ENV || 'production',
    // context: 'rollbar/test'
    client: {
      javascript: {
        code_version: version,
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
  replay: {
    enabled: true,
    autoStart: true,
    debug: {
      logEmits: false,
    },
  },
  checkIgnore: (isUncaught, args, payload) => {
    // Ignore specific errors based on the context or message
    const exception = { class: '', message: '', description: '', ...(payload?.body?.trace?.exception || {}) }
    // const message = args?.[0]?.message?.toLowerCase?.() || ''

    if (isExtensionError(exception) || exception.description.toLowerCase().includes('error getting `reason` from event')) {
      return true
    }
    // Ignore iOS WKWebView webkit bridge errors from Facebook/Instagram in-app browser (#3088)
    if (
      exception.message?.includes('window.webkit.messageHandlers') ||
      exception.description?.includes('window.webkit.messageHandlers')
    ) {
      return true
    }
    return false // Do not ignore other errors
  },
  transform: payload => {
    // Modify the payload before sending it to Rollbar
    const exception = payload?.body?.trace?.exception || {}
    if (isExtensionError(exception)) {
      // Mark the error as ignored
      payload.level = 'ignore'
    }

    if (['critical', 'error', 'warning'].includes(payload.level)) {
      // Also log the error to the browser console for visibility
      if (exception.class) {
        $logger.error(`${exception.class}: ${exception.description} > ${exception.message}`, exception)
      } else {
        const { body, extra } = payload?.body?.message || {}
        $logger.error(body || 'Unknown error', extra || {})
      }
    }

    return payload
  },
})
